module.exports = __webpack_public_path__ + "static/media/chev-down.b19ba380.svg";